/**
 * Module dependencies.
 */

import { createGlobalStyle } from 'styled-components';

/**
 * Export `GlobalStyles` component.
 */

export const GlobalStyles = createGlobalStyle`
  /* CSS Reset and Base Styles */
  *, ::after, ::before, ::backdrop {
    border: 0 solid;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  /* HTML & Body */
  html {
    font-family: Raleway, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 16px;
    line-height: 1.5;
    overflow-y: unset;
    tab-size: 4;
    text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    background-color: #ffffff;
    color: #000000;
    line-height: inherit;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }

  p {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  b, strong {
    font-weight: bolder;
  }

  small {
    font-size: 80%;
  }

  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Lists */
  ol, ul, menu {
    list-style: none;
  }

  /* Media Elements */
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }

  img, video {
    height: auto;
    max-width: 100%;
  }

  /* Form Elements */
  button, input, select, optgroup, textarea {
    background-color: transparent;
    border-radius: 0;
    color: inherit;
    font: inherit;
    letter-spacing: inherit;
    opacity: 1;
  }

  ::file-selector-button {
    appearance: button;
    background-color: transparent;
    border: 0 solid;
    border-radius: 0;
    box-sizing: border-box;
    color: inherit;
    font: inherit;
    letter-spacing: inherit;
    margin: 0;
    margin-inline-end: 4px;
    opacity: 1;
    padding: 0;
  }

  button, input:where([type="button"], [type="reset"], [type="submit"]) {
    appearance: button;
  }

  ::placeholder {
    color: currentcolor;
    opacity: 1;
  }

  textarea {
    resize: vertical;
  }

  ::-webkit-search-decoration {
    appearance: none;
  }

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }

  /* Select elements */
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }

  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }

  /* Table */
  table {
    border-collapse: collapse;
    border-color: inherit;
    text-indent: 0;
  }

  /* Other Elements */
  hr {
    border-top-width: 1px;
    color: inherit;
    height: 0;
  }

  abbr:where([title]) {
    text-decoration: underline dotted;
  }

  progress {
    vertical-align: baseline;
  }

  summary {
    display: list-item;
  }

  code, kbd, samp, pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em;
  }

  /* Browser-specific */
  :-moz-focusring {
    outline: auto;
  }

  :-moz-ui-invalid {
    box-shadow: none;
  }

  /* Webkit datetime */
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }

  ::-webkit-datetime-edit {
    display: inline-flex;
    padding-block: 0;
  }

  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }

  ::-webkit-datetime-edit-year-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-minute-field,
  ::-webkit-datetime-edit-second-field,
  ::-webkit-datetime-edit-millisecond-field,
  ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }

  /* Hidden attribute */
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
`;
